/**
 * Timer Display Component
 * Shows the running stopwatch and stop button
 */
import { StopCircle } from 'lucide-react'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'

import { Button } from '@/components/elements/button'
import { useStopwatch } from '@/hooks/useStopwatch'

export function TimerDisplay({ onStop }) {
  const { formatTime, start, isRunning } = useStopwatch(false)
  const time = formatTime()

  // Start the timer when component mounts
  useEffect(() => {
    if (!isRunning) {
      start()
    }
  }, [start, isRunning])

  return (
    <div className="bg-primary text-primary-foreground flex flex-col items-center justify-between gap-3 px-4 py-3 sm:flex-row sm:gap-4 sm:px-6 sm:py-4">
      <div className="flex w-full items-center justify-center gap-3 sm:w-auto sm:justify-start sm:gap-4">
        <div className="font-mono text-3xl font-bold tabular-nums sm:text-4xl">
          {time.formatted}
        </div>
        <div className="text-primary-foreground/70 text-xs sm:text-sm">
          <div>Drill in Progress</div>
        </div>
      </div>

      <Button
        variant="destructive"
        size="lg"
        onClick={onStop}
        className="flex w-full items-center gap-2 sm:w-auto"
      >
        <StopCircle className="h-5 w-5" />
        Complete Drill
      </Button>
    </div>
  )
}

TimerDisplay.propTypes = {
  onStop: PropTypes.func.isRequired,
}
